export default {
  id: 168,
  title: 'Target #168 - Carpet',
  url: 'https://cssbattle.dev/play/168',
  colors: ['#0D1335', '#DC6638'],
  solution:
    '<a a><a b><a c><a d><style>[a],[b]{top:0}[a],[c]{left:0}[c],[d]{bottom:0}[b],[d]{right:0}body{margin:0;background:#0d1335}a{position:fixed;width:70;height:20;background:#dc6638;box-shadow:0 0 0 20px #0d1335,0 0 0 40px #dc6638,0 0 0 60px #0d1335,0 0 0 80px #dc6638,0 0 0 100px #0d1335,0 0 0 120px #dc6638}</style>',
}
